import React from 'react'
import { PageHeader } from 'SRC/ui'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getProfileAdsQuery } from '../../../selectors'
import { Menu, List } from 'SRC/modules/ads/list/components/My'
import { ProfileAdsPagination } from 'SRC/modules/ads/pagination/components'

const Ads = ({ query: { status } }) => [
  <PageHeader key='header'>Moji oglasi</PageHeader>,
  <div key='content'>
    <Menu />
    <List />
    {status !== 'all' ? <ProfileAdsPagination /> : null}
  </div>
]

Ads.propTypes = {
  query: PropTypes.shape({
    status: PropTypes.string.isRequired
  })
}

const mapStateToProps = state => ({
  query: getProfileAdsQuery(state)
})

export default connect(mapStateToProps)(Ads)
